import TProgress from './progress.vue'

TProgress.install = Vue => {
  Vue.component(TProgress.name, TProgress)
}

export default TProgress



// WEBPACK FOOTER //
// ./src/module/progress/index.js